import { SupportedLanguage } from '@/enum'
import { DropdownOption } from '@/types'

export const KULDEVTAS_OPTIONS: DropdownOption = {
  [SupportedLanguage.English]: [],
  [SupportedLanguage.Hindi]: [],
  [SupportedLanguage.Bengali]: [],
  [SupportedLanguage.Telugu]: [],
  [SupportedLanguage.Marathi]: [
    'खंडोबा',
    'तुळजाभवानी',
    'महालक्ष्मी (कोल्हापूर)',
    'रेणुका माता',
    'एकवीरा देवी',
    'जेजुरी खंडोबा',
    'कालिका माता',
    'योगेश्वरी देवी',
    'श्री देव रामनाथ',
    'श्री विठोबा-रखुमाई',
    'श्री सप्तश्रृंगी देवी',
    'श्री देवी महालसा',
    'श्री अंबाबाई',
    'श्री भैरवनाथ',
    'श्री नृसिंह सरस्वती',
    'श्री दत्तात्रेय',
    'श्री गणपती (श्री क्षेत्र मूढगाव)',
    'श्री देवी साटेश्वरी',
    'श्री देव भैरव',
    'श्री देव विठोबा (पंढरपूर)',
  ],
  [SupportedLanguage.Tamil]: [],
  [SupportedLanguage.Gujarati]: [],
  [SupportedLanguage.Kannada]: [],
  [SupportedLanguage.Malayalam]: [],
  [SupportedLanguage.Odia]: [],
}
